<template>
    <b-container fluid>
        <b-row class="justify-content-center align-items-stretch">
            <b-col cols="12" md="12" class="text-left mb-3">
                <inter-card>
                    <h4 class="text-primary">Seleziona la partita che ti interessa.</h4>
                    <p>Scegli la partita a cui voler partecipare tra quelle disponibili in seguito.<br />
                    Nel box della singola gara sono riportati il prezzo del biglietto ed il numero minimo di partecipanti; selezionala per vedere i dettagli sulle disponibilit&agrave; residue e procedere con l'inserimento della richiesta.</p>
                </inter-card>
            </b-col>
            <b-col cols="12" md="4">
                <inter-card
                        titleIcon="flaticon-football"
                        title="Partita Selezionata">
                    <template v-if="matchSelected.id">
                        <div class="d-flex align-items-center">
                            <div>
                                <div class="media" style="width: 80px">
                                    <img :src="matchLogo(matchSelected.competizione)" class="img-thumbnail" alt="logo"/>
                                </div>
                            </div>
                            <div class="flex-grow-1 text-center">
                                <h4 class="mb-1">{{matchSelected.opponent}}</h4>
                                <p class="mb-1">Data: {{matchSelected.date | date}}</p>
                            </div>
                        </div>

                    </template>
                    <template v-else>
                        <div class="text-center">
                            <b-alert variant="warning" show>
                                Nessuna partita selezionata
                            </b-alert>
                        </div>
                    </template>


                </inter-card>
            </b-col>
            <b-col cols="12" md="8">
                <inter-card
                        titleIcon="flaticon-armchair"
                        title="Posti disponibili">
                    <div v-if="matchSelected.id" class="d-flex small justify-content-between">

                        <div class="mx-1 flex-grow-1"
                             v-for="(sector, index) in matchSelected.sectors" v-bind:key="index">
                            <b-card no-body v-if="sectorsStatus[sector.id]">
                                <b-card-header class="p-1 text-center">
                                    {{sectorsStatus[sector.id].name}}
                                </b-card-header>
                                <div class="p-1 text-center">
                                    {{getFreePercent(sectorsStatus[sector.id].busy, sectorsStatus[sector.id].total) | percent}}
                                </div>
                            </b-card>
                        </div>
                    </div>
                    <div v-else class="text-center">
                        <b-alert variant="warning" show>
                            Nessuna partita selezionata
                        </b-alert>
                    </div>
                </inter-card>
            </b-col>
        </b-row>
        <hr>
        <b-row class="justify-content-center align-items-center">
            <b-col cols="12" md="10" class="mb-3">
                <b-row v-if="matches.length">
                    <b-col v-for="(match, index) in matches" v-bind:key="index" cols="12" md="6" class="mb-3">
                        <society-matches-match-container
                                :isSelected="matchSelected.id === match.id"
                                @onSelect="selectMatch"
                                :match="match">
                        </society-matches-match-container>
                    </b-col>
                </b-row>
                <b-row v-else>
                    <b-col cols="12" md="6">
                        <b-alert variant="warning" show>
                            Non sono disponibili partite al momento
                        </b-alert>
                    </b-col>
                </b-row>

            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import SocietyMatchesMatchContainer from "../society-matches-match-container/SocietyMatchesMatchContainer";
    import Match from '@/models/Match';
    import InterCard from "../../../../components/card/InterCard";
    import {mapActions} from 'vuex';
    import MatchService from "@/services/match-service";

    export default {
        name: "SocietyMatchWizardsStepTwo",
        components: {InterCard, SocietyMatchesMatchContainer},
        data() {
            return {
                matchSelected: Object.assign({}, Match),
                sectorsStatus: []
            }
        },
        props: {
            matches: {
                type: Array,
                default: () => []
            },
        },
        methods: {

            ...mapActions({
                societyMatchesGetSectorAvailability: 'societyMatchesGetSectorAvailability'
            }),

            matchLogo: function (competition) {
                return MatchService.getCompetitionLogo(competition)

            },

            selectMatch: function (match) {
                this.matchSelected = match;
                this.$emit('onSelectMatch', match);

                this.societyMatchesGetSectorAvailability({
                    idMatch: match.id,
                }).then((data) => {
                    this.sectorsStatus = data;
                    this.$emit('onSectorsStatus', data);
                }).catch( () => {
                    this.$bvToast.toast('Problema nel caricamento delle disponibilità', {
                        title: 'Alert',
                        variant: 'warning'
                    });
                });
            },
            validate: function () {

                if (this.matchSelected.id) {
                    return true;
                } else {
                    this.$bvToast.toast('Devi selezionare una partita', {
                        title: 'Alert',
                        variant: 'warning'
                    });
                    return false;
                }

            },

            getFreePercent: function(busy, total) {
                return Math.round(100*(total-busy) / total);
            }
        }
    }
</script>

<style scoped>

</style>
